import React, { useRef, useState } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useAuth } from '../../hooks/useAuth';
import { useEffect } from 'react';
// import { getSiteSetting } from '../../services/user-services';
import { getLangSetting } from "../../services/user-services";
import { getMatGroups } from "../../services/material-services";
import { useFetchLang } from '../../hooks/fetchs-site';
import { useNavigate } from 'react-router-dom';


function findFromLang(array, title) {
    if(array){
        return array.find((element) => {
            return element.title.toLowerCase() === title.toLowerCase()
        })
    }
    return array
}

function findFromCountry(array, country) {
    if(array){
        return array.find((element) => {
            return element.country.toLowerCase() === country.toLowerCase()
        })
    }
    return array
}


export default function ElementLang() {
    const { setAuthLang, authDataLang, setAuthGroup } = useAuth()
    const [open, setOpen] = useState(false)
    const anchorRef = useRef(null)
    const [selectedIndex, setSelectedIndex] = useState('')
    // const [loading, setLoding] = useState(false)
    // const [error, setError] = useState(false)
    const [ dataLang ] = useFetchLang('')
    const navigate = useNavigate()

    useEffect(()=>{
        // console.log('ElementLang', authDataLang)
        if(authDataLang){
            // console.log(getLangOption(authDataLang?.title), options.indexOf(authDataLang?.title))
            setSelectedIndex(authDataLang)
        }else if(dataLang){
            // console.log('isMobile:', findArrayElementByTitle(dataLang, 'iran'))
            let lagNow = findFromCountry(dataLang, 'iran')
            // console.log('lagNow', lagNow)
            // setAuthLang(lagNow)
            setSelectedIndex(lagNow)
        }
        
    }, [authDataLang, dataLang])

    const handleClick = () => {
        // console.info(selectedIndex?.title, dataLang)
        setAuthLang(findFromLang(dataLang, selectedIndex?.title))
    }

    const getGroupList = async (idLang) =>{
        const data = await getMatGroups(idLang, '')
        return data
    }
    const getDataSetting = async (idLang) =>{
        const data = await getLangSetting(idLang)
        return data
    }

    const getGroup = async(lId) => {
        const groupList = await getGroupList(lId, "")
        const numRows = groupList.length
        if(numRows > 0){
            if(numRows > 1){
                // console.log(groupList[0])
                setAuthGroup(groupList[0])
            }else{
                setAuthGroup(groupList)
            }
        }
    }

    const getDataSite = async(lId) => {
        const dataSetting = await getDataSetting(lId)
        if(dataSetting){
            setAuthLang(dataSetting)
        }
        // return dataSetting
    }

    const handleMenuItemClick = (event, index) => {

        getGroup(index?.id)

        getDataSite(index?.id)
                // let lang = findFromLang(dataLang, index)
        // console.info(index)
        // setLoding(true)
        // const getSiteInfo = async() =>{
        //     await getSiteSetting(index?.id)
        //     .then(data => {
        //         console.log('handleMenuItemClick', data)
        //         // if(data){
        //         //     if (data.length > 0){
        //         //         setAuthSetting(data[0])
        //         //     }
        //         // }
        //         setLoding(false)
        //         setError(false)
        //     }).catch( e => {
        //         setError(true)
        //         setLoding(false)
        //     })
        // }
        // getSiteInfo()

        setSelectedIndex(index)
        setAuthLang(index)
        // setAuthSetting(authDataLang?.site_langs)
        setOpen(false)
        navigate('/')
        // window.location.href = '/'
    }

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return
        }

        setOpen(false)
    }

    return (
        <React.Fragment>
            <ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
                <Button onClick={handleClick}>{selectedIndex?.title}</Button>
                <Button
                    size="small"
                    aria-controls={open ? 'split-button-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <ArrowDropDownIcon />
                </Button>
            </ButtonGroup>
            <Popper
                sx={{
                  zIndex: 1,
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                    transformOrigin:
                        placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList id="split-button-menu" autoFocusItem>
                            {dataLang && dataLang?.map((option) => (
                                <MenuItem
                                    key={option.id}
                                    disabled={!option.view_show}
                                    selected={option.id === selectedIndex.id}
                                    onClick={(event) => handleMenuItemClick(event, option)}
                                  >
                                    {option.title}
                                </MenuItem>
                            ))}
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
                )}
            </Popper>
        </React.Fragment>
    )
}